import { css } from '@emotion/react';

import { getTheme } from 'src/utils/get-theme';

const { theme } = getTheme();

export const styles = {
    wrapper: css({
        display: 'flex',
        height: '100vh',
        fontFamily:
            'Radikal, system-ui, -apple-system, Roboto, "Open Sans", "Helvetica Neue", sans-serif',
        overflow: 'hidden',
        '@media screen and (max-width: 1023px)': {
            flexDirection: 'column',
            alignItems: 'center',
        },
    }),

    preview: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.common.white,
        flex: '1 0 50%',
        padding: '100px',
        backgroundImage: `
            linear-gradient(
                180deg,
                rgba(0,0,0,0.40) 0%,
                rgba(0,0,0,0) 100%
            ),
            linear-gradient(
                0deg,
                rgba(0,0,0,0.2),
                rgba(0,0,0,0.2)
            ),
            url("https://assets.vitastudent.com/concierge/images/login-backgroundb.jpeg")
        `,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',

        '@media screen and (max-width: 1023px)': {
            display: 'none',
        },
    }),

    previewContainer: css({
        textAlign: 'center',
        marginTop: '200px',
    }),

    login: css({
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'auto',
        padding: '24px',
        '@media screen and (min-width: 735px) and (max-width: 1023px)': {
            width: '60%',
        },
    }),

    loginContainer: css({
        width: '470px',
        flexShrink: 0,
        margin: 'auto 0',
        padding: '50px',
        backgroundColor: 'white',

        '@media screen and (max-width: 1023px)': {
            position: 'relative',
            width: '100%',
        },
    }),

    headerBox: css({
        marginBottom: '20px',
    }),

    content: css({
        gap: '20px',
        display: 'flex',
        flexDirection: 'column',
    }),

    inputsWrap: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        marginBottom: '28px',
    }),

    welcomeTitle: css({
        margin: '60px 0 24px 0',
        fontFamily: 'Radikal, sans-serif',
        textTransform: 'uppercase',
        fontSize: '60px',
        lineHeight: 1,

        '@media screen and (min-width: 1023px) and (max-width: 1225px)': {
            fontSize: '50px',
        },

        '@media screen and (max-width: 1077px)': {
            fontSize: '45px',
        },
    }),

    subtitle: css({
        fontSize: '16px',
        fontWeight: 400,
    }),

    logos: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        marginTop: '40px',
    }),

    line: css({
        width: '20px',
        stroke: theme.palette.common.white,
        '@media screen and (max-width: 1023px)': {
            stroke: theme.palette.common.black,
        },
    }),

    cardIcon: css({
        backgroundColor: theme.palette.common.black,
        padding: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
    }),

    marginTop: css({
        marginTop: '8px',
    }),

    errorWrap: css({
        border: `1px solid ${theme.palette.error.main}`,
        backgroundColor: theme.palette.error.light,
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
    }),

    inputField: css({
        '& .MuiOutlinedInput-root': {
            borderRadius: '10px',

            '& fieldset': {
                borderColor: theme.palette.common.black,
            },

            '&.Mui-focused fieldset': {
                borderColor: theme.palette.common.black,
            },
        },
    }),

    button: css({
        marginBottom: '15px',
        color: theme.palette.common.white,
        textTransform: 'uppercase',
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            borderColor: theme.palette.grey[900],
        },
        '&:active': {
            borderColor: theme.palette.grey[900],
        },
        '&:focus': {
            borderColor: theme.palette.grey[900],
        },
    }),

    secondaryButton: css({
        appearance: 'none',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        color: theme.palette.text.secondary,
        fontWeight: 300,
        fontSize: '14px',
        position: 'relative',
        '&::after': {
            content: "''",
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '1px',
            backgroundColor: theme.palette.text.secondary,
        },
    }),

    resendCodeButton: css({
        textTransform: 'uppercase',
        ':hover': {
            background: 'none',
            border: 'none',
            color: theme.palette.primary.main,
        },
    }),

    passwordLoginSecondaryButtons: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '10px',
        marginTop: '10px',
        '@media screen and (max-width: 1023px)': {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '20px',
        },
    }),

    loginTypeSwitchWrap: css({
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
    }),

    loginRetryOtpWrap: css({
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: '28px',
    }),

    card: css({
        maxWidth: '520px',
        gap: '20px',
    }),

    headerLineHeight: css({
        lineHeight: 1.5,
        marginBottom: '20px',
        textTransform: 'uppercase',
    }),
};
